module.exports = __webpack_public_path__ + "img/zzzbtlogo.a25d8f0a.png";